export default "__VITE_ASSET__CrfB_PTj__ 1920w";